import { writable } from 'svelte/store';

export function createConfirm() {
  const isOpen = writable(false);
  const message = writable('');
  let callback: (() => void) | null = null;

  function show(msg: string, onConfirm: () => void) {
    message.set(msg);
    callback = onConfirm;
    isOpen.set(true);
  }

  function close(confirmed: boolean) {
    isOpen.set(false);
    if (confirmed && callback) callback();
    callback = null;
  }

  return { isOpen, message, show, close };
}
